export default __webpack_public_path__ + "static/comparisons-app-creation--mobile-0af95c719659dce9a222a10e6ee619d5.png";